"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DraggableResizable = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRnd = require("react-rnd");

var _constants = require("../constants");

var _props = require("../props");

var _actions = require("../store/actions");

var _utilities = require("../utilities");

var _Style = _interopRequireDefault(require("./Style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(Object(source)); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var DraggableResizable =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DraggableResizable, _PureComponent);

  function DraggableResizable(props) {
    var _this;

    _classCallCheck(this, DraggableResizable);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DraggableResizable).call(this, props));
    var heightInitial = props.heightInitial,
        widthInitial = props.widthInitial;
    _this.getX = _this.getX.bind(_assertThisInitialized(_this));
    _this.getY = _this.getY.bind(_assertThisInitialized(_this));
    _this.handleResize = _this.handleResize.bind(_assertThisInitialized(_this));
    _this.resetPosition = _this.resetPosition.bind(_assertThisInitialized(_this));
    _this.handleResizeDebounced = (0, _utilities.debounce)(_this.handleResize, 50);
    _this.state = {
      height: heightInitial,
      width: widthInitial,
      x: _this.getX(),
      y: _this.getY()
    };
    return _this;
  }

  _createClass(DraggableResizable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResizeDebounced);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResizeDebounced);
    }
  }, {
    key: "getX",
    value: function getX() {
      var _this$props = this.props,
          position = _this$props.position,
          widthInitial = _this$props.widthInitial;
      var x = position === _constants.POSITION_LEFT ? 20 : window.innerWidth - widthInitial - 20;
      if (x < 0) x = 0;
      return x;
    }
  }, {
    key: "getY",
    value: function getY() {
      var _this$props2 = this.props,
          affordance = _this$props2.affordance,
          heightInitial = _this$props2.heightInitial;
      var y = affordance ? window.innerHeight - heightInitial - 100 : window.innerHeight - heightInitial - 20;
      if (y < 0) y = 0;
      return y;
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this2 = this;

      var breakpoint = this.props.breakpoint;
      var _this$state = this.state,
          height = _this$state.height,
          width = _this$state.width,
          x = _this$state.x,
          y = _this$state.y;
      var heightNew = height;
      var widthNew = width;
      var xNew = x;
      var yNew = y;
      if (window.innerWidth <= breakpoint) return;

      if (window.innerWidth < width) {
        xNew = 0;
        widthNew = window.innerWidth;
      } else if (x + width > window.innerWidth) {
        xNew = window.innerWidth - width;
      }

      if (window.innerHeight < height) {
        yNew = 0;
        heightNew = window.innerHeight;
      } else if (y + height > window.innerHeight) {
        yNew = window.innerHeight - height;
      }

      this.setState({
        height: heightNew,
        width: widthNew,
        x: xNew,
        y: yNew
      }, function () {
        // necessary because of bug where container renders off-screen after resize
        _this2.forceUpdate();
      });
    }
  }, {
    key: "resetPosition",
    value: function resetPosition() {
      var _this$props3 = this.props,
          heightInitial = _this$props3.heightInitial,
          widthInitial = _this$props3.widthInitial;
      this.setState({
        height: heightInitial,
        width: widthInitial,
        x: this.getX(),
        y: this.getY()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      // eslint-disable-line complexity
      var _this$props4 = this.props,
          affordance = _this$props4.affordance,
          breakpoint = _this$props4.breakpoint,
          disableDrag = _this$props4.disableDrag,
          disableResize = _this$props4.disableResize,
          heightMax = _this$props4.heightMax,
          heightMin = _this$props4.heightMin,
          minimized = _this$props4.minimized,
          widthMax = _this$props4.widthMax,
          widthMin = _this$props4.widthMin,
          zIndex = _this$props4.zIndex;
      var _this$state2 = this.state,
          height = _this$state2.height,
          width = _this$state2.width,
          x = _this$state2.x,
          y = _this$state2.y;
      var shouldDisableDrag = disableDrag || window.innerWidth <= breakpoint;
      var windowHeightIsLessThanHeight = affordance ? window.innerHeight < height + 100 : window.innerHeight < height + 20;
      var windowWidthIsLessThanWidth = window.innerWidth < width;
      var windowHeightIsLessThanHeightMin = affordance // eslint-disable-line id-length
      ? window.innerHeight < heightMin + 100 : window.innerHeight < heightMin + 20;
      var heightAdjustedSmall = affordance ? window.innerHeight - 100 : window.innerHeight;
      var heightAdjusted = windowHeightIsLessThanHeight ? heightAdjustedSmall : height;
      var widthAdjusted = windowWidthIsLessThanWidth ? window.innerWidth : width;
      var minHeightAdjusted = windowHeightIsLessThanHeightMin ? window.innerHeight : heightMin;
      var minWidthAdjusted = windowWidthIsLessThanWidth ? window.innerWidth : widthMin;
      return _react.default.createElement(_react.Fragment, null, _react.default.createElement(_reactRnd.Rnd, {
        bounds: "window",
        className: (0, _classnames.default)('help--floating-container', minimized ? 'help--is-hidden' : ''),
        disableDragging: shouldDisableDrag,
        dragHandleClassName: "help--drag-handle",
        enableResizing: disableResize || window.innerWidth <= breakpoint ? false : {
          bottom: true,
          bottomLeft: true,
          bottomRight: true,
          left: true,
          right: true,
          top: true,
          topLeft: true,
          topRight: true
        },
        maxHeight: heightMax,
        maxWidth: widthMax,
        minHeight: minHeightAdjusted,
        minWidth: minWidthAdjusted,
        size: {
          height: heightAdjusted,
          width: widthAdjusted
        },
        position: {
          x: x,
          y: y
        },
        onDragStop: function onDragStop(event, data) {
          // return if clicked but not dragged
          if (x === data.x && y === data.y) return;

          _this3.setState({
            x: data.x,
            y: data.y
          });

          _this3.props.appDragXSet(data.x);

          _this3.props.appDragYSet(data.y);

          _this3.props.trafficDrag();
        },
        onResizeStop: function onResizeStop(event, direction, ref, delta, position) {
          // return if clicked but not resized, also fixes bug where container shoots to top-left
          if (delta.height === 0 && delta.width === 0) return;

          _this3.setState(_objectSpread({
            height: ref.style.height,
            width: ref.style.width
          }, position));

          _this3.props.appResizeHeightSet(ref.style.height);

          _this3.props.appResizeWidthSet(ref.style.width);

          _this3.props.trafficResize();
        }
      }, this.props.render({
        resetPosition: this.resetPosition
      })), _react.default.createElement(_Style.default, {
        css: "\n          .help--drag-handle {\n            cursor: ".concat(shouldDisableDrag ? 'inherit' : 'grab', ";\n          }\n          .help--drag-handle:active {\n            cursor: ").concat(shouldDisableDrag ? 'inherit' : 'grabbing', ";\n          }\n\n          .help--floating-container {\n            border: 1px solid #DDDDDD;\n            box-shadow: rgba(0, 0, 0, 0.16) 0px 5px 40px;\n            position: fixed !important;\n            z-index: ").concat(zIndex, ";\n          }\n          @media (max-width: ").concat(breakpoint, "px) {\n            .help--floating-container {\n              bottom: 0;\n              box-shadow: none;\n              left: 0;\n              right: 0;\n              top: 0;\n\n              height: 100% !important;\n              max-height: 100% !important;\n              max-width: 100% !important;\n              min-height: 100% !important;\n              min-width: 100% !important;\n              transform: none !important;\n              width: 100% !important;\n            }\n          }\n        ")
      }));
    }
  }]);

  return DraggableResizable;
}(_react.PureComponent);

exports.DraggableResizable = DraggableResizable;
DraggableResizable.propTypes = {
  affordance: _props.propTypes.affordance,
  appDragXSet: _propTypes.default.func.isRequired,
  appDragYSet: _propTypes.default.func.isRequired,
  appResizeHeightSet: _propTypes.default.func.isRequired,
  appResizeWidthSet: _propTypes.default.func.isRequired,
  breakpoint: _props.propTypes.breakpoint,
  disableDrag: _propTypes.default.bool.isRequired,
  disableResize: _propTypes.default.bool.isRequired,
  heightInitial: _props.propTypes.heightInitial,
  heightMax: _props.propTypes.heightMax,
  heightMin: _props.propTypes.heightMin,
  minimized: _propTypes.default.bool.isRequired,
  position: _props.propTypes.position,
  render: _propTypes.default.func.isRequired,
  trafficDrag: _propTypes.default.func.isRequired,
  trafficResize: _propTypes.default.func.isRequired,
  widthInitial: _props.propTypes.widthInitial,
  widthMax: _props.propTypes.heightMax,
  widthMin: _props.propTypes.widthMin,
  zIndex: _props.propTypes.zIndex
};
DraggableResizable.defaultProps = {
  affordance: _props.defaultProps.affordance,
  breakpoint: _props.defaultProps.breakpoint,
  disableDrag: false,
  disableResize: false,
  heightInitial: _props.defaultProps.heightInitial,
  heightMax: _props.defaultProps.heightMax,
  heightMin: _props.defaultProps.heightMin,
  position: _props.defaultProps.position,
  widthInitial: _props.defaultProps.widthInitial,
  widthMax: _props.defaultProps.heightMax,
  widthMin: _props.defaultProps.widthMin,
  zIndex: _props.defaultProps.zIndex
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    dragX: state.app.dragX,
    dragY: state.app.dragY,
    minimized: state.app.minimized,
    resizeHeight: state.app.resizeHeight,
    resizeWidth: state.app.resizeWidth
  };
};

var mapDispatchToProps = {
  appDragXSet: _actions.appDragXSet,
  appDragYSet: _actions.appDragYSet,
  appResizeHeightSet: _actions.appResizeHeightSet,
  appResizeWidthSet: _actions.appResizeWidthSet,
  trafficDrag: _actions.trafficDrag,
  trafficResize: _actions.trafficResize
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DraggableResizable);

exports.default = _default;